/**
 * Page 1: confirmation.
 *
 * Shown straight after a successful submit on a landing page, never after a
 * failed one. Static by design: the welcome email is sent when the feed is
 * actually ready, so there is nothing here to poll and nothing to promise about
 * timing beyond "a few minutes".
 *
 * No app header, because there is no feed to navigate to yet. Hence the
 * confirmation header variant: white bar, divider, orange logo alone.
 */

import React from 'react';

import TrialShell from './TrialShell';
import { useFocusHeading } from './useTrialPage';
import { EVENTS, track } from '../../analytics/campaignAnalytics';

export default function ConfirmationPage() {
  const heading = useFocusHeading(true);

  return (
    <TrialShell
      token={null}
      onContactClick={() => track(EVENTS.CONTACT_CLICKED)}
      onSiteClick={() => track(EVENTS.SITE_LINK_CLICKED)}
    >
      <main className="tr-main tr-main--centred">
        <div className="tr-wrap tr-wrap--narrow">
          <div
            aria-hidden="true"
            style={{
              width: 64, height: 64, borderRadius: '50%', margin: '0 auto',
              background: 'rgba(255,107,53,0.12)', display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: 26,
            }}
          >
            &#9993;
          </div>
          <h1 className="tr-h1 tr-h1--large" tabIndex={-1} ref={heading} style={{ marginTop: 24 }}>
            Your personalized news feed is on its way!
          </h1>
          <p className="tr-lede">
            We&rsquo;re finding news stories based on your selected interests.
          </p>
          <p className="tr-body" style={{ marginTop: 8 }}>
            Check your inbox in a few minutes for your first discoveries.
          </p>
          <hr style={{ border: 0, borderTop: '1px solid rgba(60,74,94,0.12)', width: 80, margin: '28px auto' }} />
          <p className="tr-meta">No technical setup required.</p>
        </div>
      </main>
    </TrialShell>
  );
}
